import React, { Component } from 'react';
import { TreeSelect } from 'antd';
import classNames from 'classnames';
const {TreeNode } = TreeSelect;

class TreeSelectField extends Component {
  renderTree = (items) => {
    return items.map(item => {
      if(item.children && Array.isArray(item.children)){
        return <TreeNode value={item.value} title={item.title} >
          {this.renderTree(item.children)}
        </TreeNode> 
      }
      return <TreeNode value={item.value} title={item.title} /> 
    })
  }

  render() {
    const {input, disabled, meta: { touched, error }, placeholder, label, tree, handleChange } = this.props;

    return (
      <div className={classNames("create-dialog-form__group create-dialog-form__group--indent-bottom", {disabled})}>
        {label ? <label >{label}</label> : null}
        <TreeSelect
          style={{ width: '100%' }}
          value={input.value}
          placeholder={placeholder}
          treeDefaultExpandAll
          onChange={(e) => {
            input.onChange(e);
            if(handleChange){
              handleChange(e)
            }
          }}
        >
          {this.renderTree(tree)}
        </TreeSelect>
        {touched && ((error && <span style={{color: 'red'}}>{error}</span>))}
      </div>
    );
  }
}

export default TreeSelectField;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/TreeSelectField.jsx